export default "__VITE_ASSET__DXBcshHz__"